//baseUrl
const DOMAIN_NAME = {
    // URL_EASYMOCK: 'http://api.imars.com',
    // URL_EASYMOCK: '/api',
    // URL_EASYMOCK: 'http://101.37.232.125:8081',
    URL_EASYMOCK: 'https://api.xhsdscience.com',
}

export default DOMAIN_NAME



// WEBPACK FOOTER //
// ./src/server/config.js